import { Link } from 'react-router-dom';

function serviceSiteName(original) {
  return (
    <Link to={`/servicesites/edit/${original?.id}`}>
      {original?.serviceSiteName || ''}
    </Link>
  );
}

function serviceSiteCode(original) {
  return original?.serviceSiteCode || '';
}

function status(original) {
  return original?.status ? 'Active' : 'In-Active';
}

export { serviceSiteName, serviceSiteCode, status };
